import {css} from '@emotion/react';
import {useTheme} from '@mui/material';
import {DlMuiDynamicIcon, GetStylesFunction, TranslateUtils} from '@wallaby-ui/core';
import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';

import {NavigationContext} from '../useNavigationContext';

const I18N = defineMessages({
  HIDE_MENU: {
    id: 'navigation.button.toggle.action.hide',
    defaultMessage: 'Hide',
    description: 'text "hide" for navigation toggle button',
  },
  SHOW_MENU: {
    id: 'navigation.button.toggle.action.show',
    defaultMessage: 'Show',
    description: 'text "show" for navigation toggle button',
  },
  TOGGLE_TEXT: {
    id: 'navigation.button.toggle.title',
    defaultMessage: '{action} menu',
    description: 'text for navigation toggle button',
  },
});

interface OwnProps {
  navigationContext: NavigationContext;
}

type Props = OwnProps;

export const ToggleNavigationButton: React.FC<Props> = (props) => {
  const theme = useTheme();
  const styles = getStyles({theme});
  const {navigationContext} = props;
  const {isNavigationOpen, setIsNavigationOpen, setUserMenuOpen} = navigationContext;
  const intl = useIntl();
  const handleClick = () => {
    const opened = !isNavigationOpen;
    if (!opened) {
      setUserMenuOpen(false);
    }
    setIsNavigationOpen(opened);
  };
  return (
    <div data-name={'navigation-button--wrapper'} css={styles.wrapper}>
      <DlMuiDynamicIcon
        data-name={'navigation-button--icon-button'}
        onClick={handleClick}
        iconTitle={TranslateUtils.translate(I18N.TOGGLE_TEXT, intl, {
          action: TranslateUtils.translate(isNavigationOpen ? I18N.HIDE_MENU : I18N.SHOW_MENU, intl),
        })}
        inputCss={styles.button}
        iconName={isNavigationOpen ? 'closeMenu' : 'openMenu'}
        svgIconInputCss={styles.icon}
        noButtonStyles
      />
    </div>
  );
};

ToggleNavigationButton.displayName = 'ToggleNavigationButton';

const getStyles: GetStylesFunction = (options) => ({
  wrapper: css`
    position: absolute;
    right: -16px;
    top: 43px;
    height: 40px;
    width: 40px;
    z-index: 1000;
  `,
  button: css({
    'zIndex': '1000',
    'height': '32px',
    'width': '32px',
    'top': '4px',
    'left': '7px',
    'backgroundColor': `${options?.theme?.palette.custom.navigationButton}`,

    '&:hover, &:active': {
      backgroundColor: `${options?.theme?.palette.custom.navigationButtonHover}`,
    },
  }),
  icon: css`
    color: white;
    display: flex;
    align-content: center;
    width: 16px;
    height: 16px;
  `,
});
